import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TagState = {
  id: string,
  karat: string,
  category: string,
  subCategory: string,
  name: string,
  count: number,
}



const initialState: TagState[] = [];

const productTagSlice = createSlice({
  name: 'productTags',
  initialState,
  reducers: {
    setTag: (state, action: PayloadAction<TagState[]>) => {
      return action.payload;
    },
    resetTag: () => {
      return initialState;
    }
  }

});

export const { setTag, resetTag } = productTagSlice.actions;
export default productTagSlice.reducer;